/****************************************************
 * Module Name:  kapanCreationDetailModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { DataGridPro, } from "@mui/x-data-grid-pro";
import { Box, Button, Container, Typography } from "@mui/material";
import Constants from "../../../utility/constants";
import Modal from "react-bootstrap/Modal";
import "./../../../style/modalstyle.css";
import logo from '../../../images/pansuriya.jpg'
import Utility from "../../../utility/utility";

const KapanCreationDetailModal = ({ data, handleClose }) => {

  const columnName = [
    {
      field: "lotcreationid",
      headerName: "LOT CREATION ID",
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "carats",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      width: 170,
    },
    {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 210,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
  ];

  const rows = data.lots;
  const columns = columnName;
  return (
    <div>
      <Modal show={true} onHide={handleClose} dialogClassName="modalSize-sm" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Kapan Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container maxWidth="xxl">
            <Box height={120} width={"100%"}>
              <Typography mb={2}>
                <strong>Kapan Id</strong> -- {data.lotid}
              </Typography>
              <Typography my={1}>
                <strong>Created At</strong> --{" "}
                {Utility.ConvertUtcToLocalDate(data.createdat)}
              </Typography>
              <Typography my={2}>
                <strong>Created By</strong> -- {data.username}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeightBold,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeightBold,
                },
                height: "35vh",
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={true}
                density="compact"
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },

                  "& .lavenderCell": {
                    color: "#080808",
                    backgroundColor: "#D8BFD8",
                  },
                  "& .cursorNA": {
                    color: "#080808",
                    backgroundColor: "#D8BFD8",
                    cursor: "not-allowed"
                  },
                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeightBold,
                }}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.lotcreationid}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      locationid: false,
                      lotid: false,
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                  //   sorting: {
                  //     sortModel: [{ field: "updatedat", sort: "desc" }],
                  //   },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </Box>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KapanCreationDetailModal;
